import { memo } from 'react';
import { Box } from '@chakra-ui/react';

/**
 * @typedef {Omit<import('@chakra-ui/react').BoxProps, 'position'> & {
 * position: 'top' | 'bottom',
 * direction: 'left' | 'right'
 * }} BlockDiagonalDividerProps
 */

/** @param {BlockDiagonalDividerProps} props */
const BlockDiagonalDivider = ({ position, direction, ...props }) => {
  const isTopPosition = position === 'top';
  const isLeftDirection = direction === 'left';

  return (
    <Box
      w="calc(100% + 1px)"
      h={{ mobile: '25px', tablet: '51px', laptop: '91px' }}
      pos="absolute"
      top={isTopPosition ? '-1px' : undefined}
      bottom={isTopPosition ? undefined : '-1px'}
      transform={`${isLeftDirection ? '' : 'rotateY(180deg) '}${isTopPosition ? '' : 'rotateX(180deg)'}`}
      left={isLeftDirection ? '-1px' : undefined}
      right={isLeftDirection ? undefined : '-1px'}
      bg="ourBlack"
      clipPath="polygon(0 0, 104% 0, 0 100%)"
      {...props}
    />
  );
};

export default memo(BlockDiagonalDivider);
